var map = {
	"./404-error.jpg": 493,
	"./Languages-Translator.jpg": 3945,
	"./about/about-img1.jpg": 1370,
	"./about/about-img2.jpg": 4678,
	"./about/about-img3.jpg": 5794,
	"./about/about-img4.png": 4969,
	"./about/about-img5.png": 6273,
	"./app-development.jpg": 4901,
	"./blog/blog-details.jpg": 1113,
	"./blog/blog-img-footer.jpg": 2288,
	"./blog/blog-img-footer2.jpg": 7960,
	"./blog/blog-img-footer3.jpg": 4550,
	"./blog/blog-img1.jpg": 8671,
	"./blog/blog-img10.png": 6703,
	"./blog/blog-img11.png": 2601,
	"./blog/blog-img12.png": 2910,
	"./blog/blog-img13.jpg": 1805,
	"./blog/blog-img14.jpg": 3464,
	"./blog/blog-img15.jpg": 2797,
	"./blog/blog-img2.jpg": 33,
	"./blog/blog-img3.jpg": 9063,
	"./blog/blog-img4.jpg": 7892,
	"./blog/blog-img5.jpg": 9358,
	"./blog/blog-img6.jpg": 4411,
	"./blog/blog-img7.jpg": 931,
	"./blog/blog-img8.jpg": 1028,
	"./blog/blog-img9.jpg": 250,
	"./blog/blog-profile1.png": 1084,
	"./blog/blog-profile2.png": 9158,
	"./blog/blog-profile3.png": 6232,
	"./blog/blog-small-img1.jpg": 558,
	"./blog/blog-small-img2.jpg": 2362,
	"./blog/blog-small-img3.jpg": 7127,
	"./blog/blog-small-img4.jpg": 6238,
	"./blog/blog-small-img5.jpg": 8045,
	"./blog/blog-small-img6.jpg": 9323,
	"./blog/blog-style-img1.jpg": 5714,
	"./blog/blog-style-img2.jpg": 1889,
	"./blog/blog-style-img3.jpg": 2156,
	"./blog/blog-style-img4.jpg": 1222,
	"./books-laptop.jpg": 69,
	"./brand-logo/AK_technologies.png": 6364,
	"./brand-logo/Aptara.png": 8368,
	"./brand-logo/GC_Solutions.png": 9884,
	"./brand-logo/Hurix.png": 1991,
	"./brand-logo/Integra.png": 2650,
	"./brand-logo/LearningMate.png": 7130,
	"./brand-logo/Magic_Software.png": 9119,
	"./brand-logo/NIIT.png": 5981,
	"./brand-logo/Six_Red_Marble.png": 6634,
	"./brand-logo/Straive.png": 9735,
	"./brand-logo/XSEED.png": 2902,
	"./brand-logo/brand-bg.png": 1082,
	"./brand-logo/brand-logo1.png": 322,
	"./brand-logo/brand-logo2.png": 9654,
	"./brand-logo/brand-logo3.png": 4566,
	"./brand-logo/brand-logo4.png": 4736,
	"./brand-logo/brand-logo5.png": 2699,
	"./brand-logo/brand-logo6.png": 6489,
	"./brand-logo/brand-style1.png": 1947,
	"./brand-logo/brand-style2.png": 367,
	"./brand-logo/brand-style3.png": 8528,
	"./brand-logo/brand-style4.png": 7967,
	"./brand-logo/brand-style5.png": 2593,
	"./brand-logo/compony names/AKtechnologies.png": 469,
	"./brand-logo/compony names/Aptara.png": 7913,
	"./brand-logo/compony names/GCSolutions.png": 9930,
	"./brand-logo/compony names/HURIX.png": 2755,
	"./brand-logo/compony names/Integra.png": 1075,
	"./brand-logo/compony names/LearningMate.png": 291,
	"./brand-logo/compony names/MagicSoftware.png": 4087,
	"./brand-logo/compony names/NIIT.png": 5545,
	"./brand-logo/compony names/SixRedMarble.png": 7818,
	"./brand-logo/compony names/Straive.png": 1437,
	"./brand-logo/compony names/XSEED.png": 5973,
	"./brand-logo/partner-1.png": 3332,
	"./brand-logo/partner-2.png": 8521,
	"./brand-logo/partner-5.png": 4289,
	"./build-img.jpg": 3499,
	"./build/build-bg.png": 8371,
	"./build/build-img1.jpg": 9426,
	"./build/build-img2.jpg": 4503,
	"./build/build-img3.jpg": 7661,
	"./build/build-img4.jpg": 8553,
	"./build/build-img5.jpg": 6817,
	"./build/build-img6.jpg": 4063,
	"./build/build-play-bg.jpg": 3321,
	"./call-us/call-shap1.png": 1241,
	"./call-us/call-shap2.png": 6402,
	"./call-us/call-shap3.png": 6989,
	"./call-us/call-us-img1.png": 8000,
	"./call-us/call-us-img2.png": 186,
	"./case-study/Animation-1.jpg": 2564,
	"./case-study/Animation-2.jpg": 4610,
	"./case-study/case-details-bg.jpg": 8534,
	"./case-study/case-details.jpg": 6298,
	"./case-study/case-study1.jpg": 2651,
	"./case-study/case-study2.jpg": 8920,
	"./case-study/case-study3.jpg": 9417,
	"./case-study/case-study4.jpg": 1658,
	"./case-study/case-study5.jpg": 9785,
	"./case-study/case-study6.jpg": 1801,
	"./case-study/case-study7.jpg": 9565,
	"./case-study/case-study8.jpg": 2132,
	"./case-study/case-study9.jpg": 4447,
	"./choose-img.jpg": 7535,
	"./choose-img/choose-img1.jpg": 9804,
	"./clients-img/client-bg.png": 7076,
	"./clients-img/client-user-img1.png": 1419,
	"./clients-img/client-user-img2.png": 6904,
	"./clients-img/clients-img1.jpg": 9474,
	"./clients-img/clients-img2.jpg": 95,
	"./clients-img/clients-img3.jpg": 4650,
	"./dual-video.jpg": 3059,
	"./envato.png": 4576,
	"./home-five-img.png": 1019,
	"./home-four/home-four-bg.png": 9324,
	"./home-four/home-four-img.jpg": 209,
	"./home-four/home-four-img.png": 7834,
	"./home-four/home-four-shape.png": 1064,
	"./home-one/home-one-img1.jpg": 54,
	"./home-one/home-one-img2.jpg": 6495,
	"./home-one/home-one-img3.jpg": 5994,
	"./home-six.jpg": 8994,
	"./home-three/home-three-bg.png": 1749,
	"./home-three/home-three-img.png": 8230,
	"./home-three/home-three-shape.png": 920,
	"./home-three/home-three-sub1.jpg": 7974,
	"./home-three/home-three-sub2.jpg": 3782,
	"./home-three/home-three-sub3.jpg": 7537,
	"./home-two.jpg": 8151,
	"./industrial-fire.jpg": 9640,
	"./k12-learning.jpg": 8732,
	"./language-flag/arabic.png": 1342,
	"./language-flag/china.png": 7662,
	"./language-flag/eng.png": 2505,
	"./language-flag/germany.png": 1263,
	"./language-flag/portugal.png": 4237,
	"./logos/35.png": 4234,
	"./logos/4444.png": 8099,
	"./logos/44445.png": 3822,
	"./logos/footer-logo.png": 7898,
	"./logos/logo-1.png": 2465,
	"./logos/logo-2.png": 358,
	"./logos/lstlogo-1 - Copy.png": 484,
	"./logos/lstlogo-1.png": 2093,
	"./logos/lstlogo-10.png": 2444,
	"./logos/lstlogo-2 (2).png": 5920,
	"./logos/lstlogo-2 linkedin.png": 7381,
	"./logos/lstlogo-2.png": 7610,
	"./logos/lstlogo-3.png": 4670,
	"./logos/lstlogo-31.png": 6742,
	"./logos/lstlogo-34.png": 9753,
	"./logos/lstlogo-344.png": 7216,
	"./programming-background-collage.jpg": 8112,
	"./programming.jpg": 2383,
	"./services/service-details-img1.jpg": 4505,
	"./services/service-details-img2.jpg": 4861,
	"./services/service-details.jpg": 6922,
	"./services/services-bg.png": 5378,
	"./services/services-img1.jpg": 5067,
	"./services/services-img2.jpg": 51,
	"./services/services-img3.jpg": 2725,
	"./services/services-img4.jpg": 9389,
	"./services/services-img5.jpg": 1479,
	"./services/services-img6.jpg": 6069,
	"./services/services-img7.jpg": 8742,
	"./services/services-img8.jpg": 6091,
	"./services/services-img9.jpg": 9957,
	"./sex-harassment.jpeg": 4165,
	"./shape/bg-shape.png": 5727,
	"./shape/bg-shape2.png": 3375,
	"./shape/bg-shape3.png": 6438,
	"./shape/bg-shape4.png": 694,
	"./shape/bg-shape5.png": 2974,
	"./shape/inner-shape.png": 8797,
	"./shape/service-shape1.png": 7729,
	"./shape/shape1.png": 4896,
	"./shape/shape2.png": 4735,
	"./shape/shape3.png": 2236,
	"./shape/shape4.png": 9834,
	"./shape/work-shape.png": 677,
	"./staffaug.jpg": 5742,
	"./talk-bg.jpg": 2803,
	"./talk-bg2.jpg": 4832,
	"./team/Mithilesh.jpg": 9916,
	"./team/Nitajain.jpg": 6958,
	"./team/Soundarrajan.png": 9248,
	"./team/team-img1.jpg": 2215,
	"./team/team-img2.jpg": 2828,
	"./team/team-img3.jpg": 9337,
	"./team/team-img4.jpg": 9562,
	"./team/team-img5.jpg": 2187,
	"./team/team-img6.jpg": 9622,
	"./technology-img.jpg": 313,
	"./technology-img2.jpg": 304,
	"./terms-condition-img.jpg": 6665,
	"./user-img.jpg": 2251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;